/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-1.jpg',
    drawer: null,
    selectedPractice: null,
    posActivePractice: null,
    posActiveFacility: null,
    activeUserName: null,
  },
  mutations: {
    SET_BAR_IMAGE(state, payload) {
      state.barImage = payload
    },
    SET_DRAWER(state, payload) {
      state.drawer = payload
    },
    SET_SCRIM(state, payload) {
      state.barColor = payload
    },
    SET_PRACTICE (state, payload) {
      state.selectedPractice = payload.practice
    },
    SET_POS_PRACTICE (state, payload) {
      state.posActivePractice = payload.practice
    },
    SET_ACTIVE_USERNAME(state, payload) {
      state.activeUserName = payload.Username
    },
  },
  actions: {

  }
})
